/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import GoogleAnalytics from '../../GoogleAnalytics';
import IObservable from '../../Observable/IObservable';
import Observable from '../../Observable/Observable';
import AnimationToggleData from '../Animation/AnimationToggleData';
import InjectableComponent from '../ComponentReference/InjectableComponent';
import ObservableBooleanComponent from '../Observable/ObservableBooleanComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Slider that has two states, on and off. */
@cc._decorator.ccclass
export default class ToggleSlider extends cc.Slider
{
    @property(AnimationToggleData)
    protected animationToggleData: AnimationToggleData = new AnimationToggleData();

    @property(InjectableComponent)
    protected activeObservable: InjectableComponent<IObservable<boolean>>
        = new InjectableComponent<IObservable<boolean>>();

    /** @hidden */
    protected onLoad(): void
    {
        this.activeObservable.SetContext(ObservableBooleanComponent);
    }

    /** @hidden */
    protected start(): void
    {
        if (!this.activeObservable.Value) { this.activeObservable.Value = new Observable<boolean>(); }

        this.bindListeners();

        this.onActiveChanged();
    }

    /** @hidden */
    protected onDestroy(): void
    {
        this.unbindListeners();
    }

    /** @hidden */
    private bindListeners(): void
    {
        this.activeObservable.Value.OnChanged(() => this.onActiveChanged());

        this.handle.node.on(cc.Node.EventType.TOUCH_END, this.toggleActive.bind(this));
        this.handle.node.parent.on(cc.Node.EventType.TOUCH_END, this.toggleActive.bind(this));
    }

    /** @hidden */
    private unbindListeners(): void
    {
        if (this.activeObservable && this.activeObservable.HasValue())
        {
            this.activeObservable.Value.OffChanged(() => this.onActiveChanged());
        }

        if (this.handle && this.handle.node)
        {
            this.handle.node.off(cc.Node.EventType.TOUCH_END, this.toggleActive.bind(this));
            this.handle.node.parent.off(cc.Node.EventType.TOUCH_END, this.toggleActive.bind(this));
        }
    }

    /** Handler of active [[IObservable]] change events. */
    protected onActiveChanged(): void
    {
        if (this.activeObservable.Value.Value)
        {
            this.animationToggleData.AnimateOn();
            this.progress = 1;
        }
        else
        {
            this.animationToggleData.AnimateOff();
            this.progress = 0;
        }

        GoogleAnalytics.ToggleEvent(this.node.name, this.activeObservable.Value.Value);
    }

    /** On click, toggles [[IObservable]] boolean value. */
    private toggleActive(event: cc.Event.EventCustom): void
    {
        this.activeObservable.Value.Value = !this.activeObservable.Value.Value;

        event.bubbles = false;
    }
}
